import React from "react";
import PropTypes from "prop-types";
import { LoadingSpinner } from "@pearson-components/elements-sdk/build/dist.elements-sdk";

const LoadingIndicator = props => (
    <div className={`loading-indicator ${(props.isDark ? "is-dark" : "")}`}>
        <div>
            <LoadingSpinner />
        </div>
        <div>{props.text}</div>
    </div>
);

LoadingIndicator.propTypes = {
    text: PropTypes.string,
    isDark: PropTypes.bool
};

LoadingIndicator.defaultProps = {
    text: "Loading...",
    isDark: true
};

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/widgets/LoadingIndicator/LoadingIndicator.js